export interface CARRIER_TABLE_INTERFACE { 
    CarrierID: number, ContractGSDB: string, Selected?: boolean
    Name: string, Street: string, Postcode: number, 
    City: string, CountryID: number, CountryName: string, 
    IMCSSiteCode: string, CarrierStatusID: number, 
    Status: string, VATCode: string, CreatedOn: string, 
    CreatedBy: string, ModifiedOn: string, ModifiedBy: string , 
}

export const column_order = [
    {name:"Status", displayName:'Status' ,order : 1},
    {name:"ContractGSDB", displayName:'Contract GSDB' ,order : 2},
    {name:"Name", displayName:'Name' ,order : 3},
    {name:"Street", displayName:'Street' ,order: 4},
    {name:"Postcode", displayName:'Postcode' ,order : 5},
    {name:"City", displayName:'City' ,order : 6},
    {name:"CountryName", displayName:'Country' ,order : 7},
    {name:"IMCSSiteCode", displayName:'GSDB Site Code' ,order : 8},
    {name:"CreatedOn", displayName:'Created (Date/Time)' ,order : 9},
    {name:"ModifiedOn", displayName:'Modified (Date/Time)' ,order : 10}
]